<div class="orderQuickActions">
  <mat-icon *ngIf="!agParam?.context?.componentParent?.reducedColumns" class="pointer"
    [ngClass]="agParam.data.canEdit?'':'disabled'" (click)="editOrder()" svgIcon="edit-2" #tooltipMin="matTooltip"
    matTooltipPosition="above" matTooltip="Editar Ordem"></mat-icon>
  <mat-icon class="pointer" [ngClass]="agParam.data.canCancel?'':'disabled'" (click)="cancelOrder()" svgIcon="close"
    #tooltipMin="matTooltip" matTooltipPosition="above" matTooltip="Cancelar Ordem"></mat-icon>
  <mat-icon *ngIf="!agParam?.context?.componentParent?.reducedColumns" class="pointer" (click)="replyOrder()"
    svgIcon="corner-up-left" #tooltipMin="matTooltip" matTooltipPosition="above" matTooltip="Reenviar Ordem"></mat-icon>
</div>
